import { CommonUserappResponse } from '@/api/services/common.dto'
import { Nullable } from '@/shared/types/app.types'

// Object that represents the details of an attachment
export interface AttachmentResponse {
    attachmentId: number // Attachment Id
    atyDescription: string // Attachment type description
    atyId: number // Attachment type Id
    createdBy: CommonUserappResponse
    creationDate: string // date and time of attachment creation
    entityId: number // Related entity Id
    filename: string // Attachment filename
    hasAnnotations: boolean // true if the attachment has annotations; false otherwise
    imageHeight: Nullable<number> // Image height
    imageWidth: Nullable<number> // Image width
    length: number // Attachment length
    mimetype: string // Attachment mimetype
    notes: Nullable<string> // Additional notes of the attachment
    scale: Nullable<number> // Scale in mm
    thumbnailBytes: Nullable<string> // Attachment thumbnail content
    uri: string // Attachment URI
}

export enum ATTACHMENT_ENTITY_TYPE {
    PATIENT = 'PATIENT',
    REQUEST = 'REQUEST',
    CASE = 'CASE',
    SAMPLE = 'SAMPLE',
    PORTION = 'PORTION',
    SUBPORTION = 'SUBPORTION',
    INCIDENT = 'INCIDENT',
    COMPLEMENTARY = 'COMPLEMENTARY',
    SYNOPTIC_TEMPLATE = 'SYNOPTIC_TEMPLATE',
    USERAPP = 'USERAPP',
    LABORATORY = 'LABORATORY'
}
